import { CloseIcon, SendIcon, MicIcon } from 'assets/icons';
import { useTranslation } from 'react-i18next';

export const ChatbotUI = ({
  isOpen,
  messages,
  inputText,
  isRecording,
  isProcessing,
  isSpeaking,
  messagesEndRef,
  chatboxRef,
  onToggleChat,
  onInputChange,
  onKeyPress,
  onSendMessage,
  onToggleVoice,
}) => {
  const { t } = useTranslation();

  if (!isOpen) {
    return (
      <button className="chatbot-floating-button" onClick={onToggleChat}>
        <img src="/assets/icons/chatbot-icon.png" alt="Chatbot" />
        <span className="chatbot-floating-button-text">
          {t('chatbot_introduction')}
        </span>
      </button>
    );
  }

  return (
    <>
      <button className="chatbot-floating-button hidden" onClick={onToggleChat}>
        <img src="/assets/icons/chatbot-icon.png" alt="Chatbot" />
        <span className="chatbot-floating-button-text">
          {t('chatbot_introduction')}
        </span>
      </button>

      <div className="chatbot-container" ref={chatboxRef}>
        {/* Header */}
        <div className="chatbot-header">
          <div className="header-content">
            <div className="bot-avatar">
              <img src="/assets/icons/chatbot-icon.png" alt="Chatbot" />
            </div>
            <div className="header-text">
              <h3>{t('chatbot_name')}</h3>
              <span className="status">{t('chatbot_status')}</span>
            </div>
          </div>
          <button className="close-button" onClick={onToggleChat}>
            <CloseIcon color="white" size={20} />
          </button>
        </div>

        {/* Messages */}
        <div className="chatbot-messages">
          {messages.length < 1 ? (
            <div className="welcome-message">
              <p>{t('chatbot_first_message')}</p>
            </div>
          ) : (
            messages.map((message) => (
              <div
                key={message.id}
                className={`message ${
                  message.sender === 'user' ? 'user-message' : 'bot-message'
                }`}
              >
                <div className="message-content">
                  <p>{message.text}</p>
                </div>
                <span className="message-time">
                  {message.timestamp.toLocaleTimeString('vi-VN', {
                    hour: '2-digit',
                    minute: '2-digit',
                  })}
                </span>
              </div>
            ))
          )}

          {isProcessing && (
            <div className="message bot-message">
              <div className="message-content typing-indicator">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          )}
          <div ref={messagesEndRef} />
        </div>

        {/* Input */}
        <div className="chatbot-input">
          <button
            className={`voice-button ${isRecording ? 'recording' : ''} ${
              isProcessing ? 'loading' : ''
            }`}
            onClick={onToggleVoice}
            title={
              isProcessing
                ? t('chatbot_recording_processing')
                : isRecording
                ? t('chatbot_recording_stop')
                : t('chatbot_recording_start')
            }
            disabled={isProcessing || isSpeaking}
          >
            <MicIcon
              color={isRecording ? '#ff4444' : isSpeaking ? '#a0793c' : '#666'}
              size={20}
            />
          </button>
          <input
            type="text"
            placeholder={
              isRecording
                ? t('chatbot_input_placeholder_recording')
                : t('chatbot_input_placeholder')
            }
            value={inputText}
            onChange={onInputChange}
            onKeyPress={onKeyPress}
            disabled={isRecording || isSpeaking}
          />
          <button
            className="send-button"
            onClick={onSendMessage}
            disabled={!inputText.trim() || isRecording || isSpeaking}
          >
            <SendIcon color={inputText.trim() ? '#a0793c' : '#ccc'} size={20} />
          </button>
        </div>
      </div>
    </>
  );
};
